<div class="charge-display-container flex flex-row justify-between items-center">
    <span *ngIf="displayValue !== null"
        [matTooltip]="reviewStatus  === 'success' ? (item.suggested_price | priceEstimateBreakdown:currencyCode:conversionRate) : null"
        class="charge-value">
        {{ displayValue | hlCurrency:currencyCode:conversionRate:false | async }}
    </span>
    <span *ngIf="displayValue === null" class="no-charge">-</span>

    <mat-icon *ngIf="reviewStatus === 'error'" [matTooltip]="reviewMessage" class="status-icon error-icon">
        error
    </mat-icon>

    <mat-icon *ngIf="reviewStatus === 'warning'" [matTooltip]="reviewMessage" class="status-icon warning-icon">
        warning
    </mat-icon>

    <mat-icon *ngIf="reviewStatus === 'success'" [matTooltip]="reviewMessage" class="status-icon success-icon">
        check_circle
    </mat-icon>
</div>